<template>
  <b-modal
    ref="modal"
    hide-footer
    no-close-on-backdrop
    header-bg-variant="warning"
  >
    <template #modal-title>
      <span>
        {{ labels.title }}
      </span>
    </template>
    <p class="txt-20" v-for="(error, index) in errors" :key="`error-${index}`">
      <span class="bold text-primary">{{ index + 1 }}. {{ error.field }}</span>
      :
      {{ error.message }}
    </p>
  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex'

const props = {
  errors: {
    type: Array,
  },
}

export default {
  props,
  computed: {
    ...mapGetters({
      resources: 'resources',
    }),
    labels() {
      return this.resources.component.customSurveys.create.modals.formErrors
    },
  },
  methods: {
    show() {
      this.$refs.modal.show()
    },
    hide() {
      this.$refs.modal.hide()
    },
  },
}
</script>

<style scoped lang="scss"></style>
